<template>
  <b-card
    no-body
  >
    <b-row class="d-flex align-items-center mb-1">
      <b-col md="4">
        <h5>Session Discount Slices</h5>
      </b-col>
      <b-col md="4">
        <b-button
          size="sm"
          variant="success"
          @click="newSlice = true"
        >
          <feather-icon icon="PlusIcon" />
        </b-button>

      </b-col>
    </b-row>
    <validation-observer ref="slicingsRef">
      <b-row
        v-for="(slice, index) in slices"
        :key="index + Math.random().toString()"
      >
        <b-col md="3">
          <validation-provider
            name="From Time"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="From"
              label-for="slicing-session-from"
            >
              <b-form-input
                id="slicing-session-from"
                v-model.number="slice.from_unit"
                type="number"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="To Time"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="To"
              label-for="slicing-session-to"
            >
              <b-form-input
                id="slicing-session-to"
                v-model.number="slice.to_unit"
                type="number"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="Amount"
            rules="required"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="Amount"
              label-for="slicing-session-amount"
            >
              <b-form-input
                id="slicing-session-amount"
                v-model.number="slice.amount"
                type="number"
                :state="(userCountry == 'JO' ? !(slice.amount >= 1) : true) && !errors.length"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          md="3"
          class="d-flex align-items-center"
        >
          <b-button
            variant="flat-danger"
            @click="deleteSlicing(index)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol, BButton, BCard,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    slicings: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userCountry = userData?.country || 'JO'

    const slicesRef = ref(props.slicings ? JSON.parse(JSON.stringify(props.slicings)) : [])
    const newSlice = ref(false)
    // watch(() => props.slicings, () => {
    //   slices.value = JSON.parse(JSON.stringify(props.slicings))
    // })
    const slices = computed(() => {
      if (newSlice.value) {
        const temp = {
          from_unit: null,
          to_unit: null,
          amount: null,
        }
        slicesRef.value.push(temp)

        newSlice.value = false
      }

      return slicesRef.value
    })

    const deleteSlicing = index => {
      slicesRef.value.splice(index, 1)
    }
    const slicingsRef = ref(null)

    watch(slicesRef, async () => {
      const valid = await slicingsRef.value.validate()
      if (valid) {
        emit('session-slices', JSON.parse(JSON.stringify(slicesRef.value)))
      }
    }, { deep: true })

    return {
      slices,
      newSlice,
      slicesRef,
      deleteSlicing,
      slicingsRef,
      required,
      userCountry,
    }
  },
}
</script>
